import React from 'react';
import { describe, PropTypes } from '@elliemae/ds-props-helpers';
import { Grid } from '@elliemae/ds-grid';

const DSMobileFilterbarItem = ({ children, onClick, cols = ['min-content'] }) => (
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  <Grid data-testid="filter-bar-item-wrapper" cols={cols} pr="xxs" pt="xxs" role="button" onClick={onClick}>
    {children}
  </Grid>
);
const filterbarItemProps = {
  children: PropTypes.element.description('FilterBar Items').isRequired,
  onClick: PropTypes.func.description('Function executed when clicking filterbar item'),
};

DSMobileFilterbarItem.displayName = 'DSMobileFilterbarItem';
const FilterbarItemWithSchema = describe(DSMobileFilterbarItem);
FilterbarItemWithSchema.propTypes = filterbarItemProps;

export { DSMobileFilterbarItem, FilterbarItemWithSchema };
